import React from 'react';
import Base64 from 'Base64';

import Page from 'components/Page';
import {Badge, Card, CardBody, CardHeader, CardImg, CardLink, CardText, CardTitle, Col, Input, ListGroup, ListGroupItem, Row, Modal, ModalBody, ModalFooter, ModalHeader, Button, FormGroup, Label} from 'reactstrap';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from 'utils/constants';
import { Cookies } from 'react-cookie';

import ViewProjectTaskDetails from './ViewProjectTaskDetails.js';
import DataAdapter from './adapter/DataAdapter.js';

import ComboBox from './component/ComboBox.js';

const cookie =new Cookies();

var __PROJECT_ID__;
var __PROJECT_TASK_ID__;

class ViewProjectTask extends React.Component {
	notificationSystem = React.createRef();
	constructor(props){
		super(props);

		if(props.match){
			__PROJECT_ID__ 		= this.props.match.params.id;
			__PROJECT_TASK_ID__ = this.props.match.params.task;
		  }else{
			__PROJECT_ID__ = this.props.id;
			__PROJECT_TASK_ID__ = this.props.task;
		  }
	

		this.state = {
			quickEditTaskModal	:	false,
			task				:	[],
			task_id				:	'',
			task_project		:	'',
			task_task			:	'',
			task_type			:	0,
			task_description	:	'',
			task_percent_done	:	'',
			task_estimate_hours	:	'',
			task_real_hours		:	'',
			task_receiver_id	:	'',
			mynotes				:	'',
			date		:	this.getDate(),
			time		:	this.getTime(),
			action_percent	:0,
			action_note	:	'',
		};

		var _SQL_	=	"select * from rb_project_tasks WHERE pt_id=" + __PROJECT_TASK_ID__;
		// var _SQL_	=	"SELECT pt.pt_id, pt.prj_id, prj.prj_title AS prj_desc, pt.task_type, ty.rb_type_desc AS task_type_desc, pt.task, pt.task_status, pt.sender_id, pt.receiver_id, pt.priority, pt.expected_start_date, pt.start_date, pt.expected_end_date, pt.end_date, pt.task_description, pt.estimate_hours, pt.real_hours, pt.percent_done FROM `rb_project_tasks` pt"	+
		// 			"	INNER JOIN 	rb_projects prj ON prj.prj_id=pt.prj_id"	+
		// 			"	INNER JOIN 	rb_types ty ON ty.rb_type_no=pt.task_type and ty.rb_type='task_type'"	+
		// " WHERE pt.pt_id=" + __PROJECT_TASK_ID__;
		var dataAdapter =new DataAdapter(_SQL_);
			dataAdapter.getRecords()
						.then(data=>{
							this.setState({
								task				:	data[0],
								task_id				:	data[0].pt_id,
								task_project		:	data[0].prj_id,
								task_task			:	data[0].task,
								task_status			:	data[0].task_status,
								task_type			:	data[0].task_type,
								task_description	:	data[0].task_description,
								task_percent_done	:	data[0].percent_done,
								task_estimate_hours	:	data[0].estimate_hours,
								task_real_hours		:	data[0].real_hours,
								task_receiver_id	:	data[0].receiver_id,
								mynotes				:	data[0].note,
							});
						})
						.catch(error=>{
							console.error('Error:', error);
						})
	}
	getDate=()=>{
		var today = new Date();
		
		var date = today.toISOString().split('T')[0];
		return date;			 
	}
	getTime=()=>{
		var today = new Date();
		var time = today.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false }); //today.toISOString().split('T')[1].slice(0,5);
		return time;			 
	}

	runQuery=(query, message, type)=>{
		let formData = new FormData();
		formData.append("query", query);
		let requestOptions = {method: 'POST',headers: {'Authorization':'Basic ' + Base64.btoa('sizotech:IsKfs$m$SZV#4Eprtj7zSPbO')},body : formData};
		fetch('https://renobuilding.ca/wp-json/reno/v1/query/' , requestOptions)
			.then(response => {
				return Promise.all([response.json(),response])
			})
			.then(([responseData,response]) => {
				this.addNotification(message, type);					
			})
			.catch(error => {
				console.error('Error:', error);
			})		
	}

	onTimerStart=()=>{
		this.setState({time	:	this.getTime()})
		// setInterval(()=>{
		// 	this.setState({time	:	this.getTime()})
		// },1000)
	}
	quickEditeTask	=	(e)	=>{
		e.persist();
		if(this.state.quickEditTaskModal){
			this.setState({
				quickEditTaskModal	:	false
			});
		}else{
			this.setState({
				quickEditTaskModal	:	true
			});
			var dataAdapter =new DataAdapter("SELECT prj.prj_code, pt.* FROM rb_project_tasks pt INNER JOIN rb_projects prj ON prj.prj_id = pt.prj_id WHERE pt_id = " + e.target.attributes[0].value)
								.getRecords()
								.then((data)=>{
									this.setState({
										task_id					:	data[0].pt_id,
										task_board				:	data[0].prj_code,
										task_project			:	data[0].prj_id,
										task_task				:	data[0].task,
										task_type				:	data[0].task_type,
										task_description		:	data[0].task_description,
										task_percent_done		:	data[0].percent_done,
										task_estimate_hours		:	data[0].estimate_hours,
										task_real_hours			:	data[0].real_hours,
										task_receiver_id		:	data[0].receiver_id,
		
									});
						
								})
		}
	}
	onTypeChnageHandler=(e)=>{
		this.setState({task_type	:	e.target.value});	
		this.runQuery("UPDATE rb_project_tasks SET task_type = '" + e.target.value + "' WHERE pt_id=" + __PROJECT_TASK_ID__, 'Task Type Updated!', 'success');
	}
	onStatusChnageHandler=(e)=>{
		this.setState({task_status	:	e.target.value});	
		this.runQuery("UPDATE rb_project_tasks SET task_status = '" + e.target.value + "' WHERE pt_id=" + __PROJECT_TASK_ID__, 'Task Status Updated!', 'success');
	}
	onProjectChnageHandler=(e)=>{
		this.setState({task_project	:	e.target.value.split(',')[0], task_board	:	e.target.value.split(',')[1]});	
		this.runQuery("UPDATE rb_project_tasks SET prj_id = '" + e.target.value.split(',')[0] + "' WHERE pt_id=" + __PROJECT_TASK_ID__, 'Task Project Updated!', 'success');
	}
	onNoteChange = (e) => {
		e.persist();
		this.runQuery("UPDATE rb_project_tasks SET note='" + this.state.mynotes + "' WHERE pt_id ="  + __PROJECT_TASK_ID__ , "Your Notes has been saved.", "success");
	}

	render(){
		return (
			<Page className="DashboardPage" title={' '} >					
				<Row>
					<Col md={12} sm={12} xs={12} className="mb-3">
						<Card>
							<CardBody>							
								<CardTitle><b>#{this.state.task_id} - {this.state.task_task}</b>{'	'}
									<Badge 
										color='primary'
										data-task-id={this.state.task_id}
										onClick={async (event) => { await navigator.clipboard.writeText('#' + this.state.task_id + ' - ' + this.state.task_task); this.addNotification("Copied!", "info");									}} 
										href="javascript:(0);" className="mr-1">
										Copy
									</Badge>{'	'}
									<Badge 
										data-task-id={this.state.task_id}
										onClick={(e)=>{this.quickEditeTask(e)}}
										href="javascript:(0);" className="mr-1">
										Edit
									</Badge>

								</CardTitle>
								<CardText>
									<div  dangerouslySetInnerHTML={{ __html: this.state.task_description }} />
								</CardText>
							</CardBody>
							<ListGroup flush>
								<ListGroupItem><b>Percent Done :</b> {this.state.task_percent_done}</ListGroupItem>
								<ListGroupItem><b>Project :</b> 
								{/*
									<ComboBox onChange={this.onProjectChnageHandler} table="rb_projects" valueField="prj_id" displayField="prj_title" filterField="prj_department" filterValue="17' OR 'prj_department'<>'12" defaultValue={this.state.task_project} order="prj_code" />
									<ComboBox onChange={this.onProjectChnageHandler} table="rb_projects" valueField="prj_id,prj_code" displayField="prj_code,prj_title" filterField="prj_status" filterValue={"23' AND prj_code in (SELECT distinct rb_type_caption FROM rb_types WHERE rb_type='task_type' AND rb_type_caption <> '') AND 'x'='x"} defaultValue={this.state.task_project+','+this.state.task_board} orderby="prj_code"  />
									*/}
									<ComboBox onChange={this.onProjectChnageHandler} table="rb_projects" valueField="prj_id" displayField="prj_code,prj_title" filterField="prj_department" filterValue={"17' OR 'prj_department'<>'12"} defaultValue={this.state.task_project} orderby="prj_code"  />
									
								</ListGroupItem>
								<ListGroupItem><b>Task Type :</b> 
									<ComboBox onChange={this.onTypeChnageHandler} table="rb_types" valueField="rb_type_no" displayField="rb_type_desc" filterField="rb_type" filterValue="task_type" defaultValue={this.state.task_type} orderby="rb_type_desc" />
								{/*
									<ComboBox onChange={this.onTypeChnageHandler} table="rb_types" valueField="rb_type_no" displayField="rb_type_desc" filterField="rb_type" filterValue={"task_type' AND rb_type_caption='" + this.state.task_board + "' AND 'x'='x"} orderby="rb_type_desc" defaultValue={this.state.task_type} />
								*/}
								</ListGroupItem>
								<ListGroupItem><b>Task Status :</b> 
									<ComboBox onChange={this.onStatusChnageHandler} table="rb_types" valueField="rb_type_no" displayField="rb_type_desc" filterField="rb_type" filterValue="task_status" defaultValue={this.state.task_status} order="rb_type_no" />
								</ListGroupItem>
								<ListGroupItem><b>Estimate hours :</b> {this.state.task_estimate_hours} {/*({this.state.task_estimate_hours*60} <i>Minutes</i>)*/}</ListGroupItem>
								<ListGroupItem>
										<b>Real Hours :</b> {this.state.task_real_hours?Math.floor(this.state.task_real_hours/60) + ':' + Math.floor(this.state.task_real_hours%60) : 0} 
										{'      '}
										<button type="button" className="btn btn-outline-danger btn-sm" onClick={(e)=>{this.onCalculateHandler()}} >Calculate from Transaction</button>
								</ListGroupItem>
							</ListGroup>
						</Card>
						<Card>
							<CardBody>
								<CardTitle><b>My Notes</b></CardTitle>
							</CardBody>
							<ListGroup flush>
								<ListGroupItem>
									<textarea style={{width:'100%', height: '200'}} onChange={(e)=>{this.setState({mynotes:e.target.value});}} onBlur={this.onNoteChange} value={this.state.mynotes} />	
								</ListGroupItem>
							</ListGroup>
						</Card>
					</Col>
				</Row>
				<Row>
					<Col  md={12} sm={12} xs={12} className="mb-3">
						<Card>
							<CardBody>
								<CardTitle><b>ACTIONS</b></CardTitle>
								<CardText>
									<ViewProjectTaskDetails projectId={__PROJECT_ID__} taskId={__PROJECT_TASK_ID__} />
								</CardText>
							</CardBody>
						</Card>
					</Col>
				</Row>
				<NotificationSystem ref={this.notificationSystem} style={NOTIFICATION_SYSTEM_STYLE}/>
				{this.quickEditTasktForm()}
			</Page>
		);
	}

	quickEditTasktForm = () => {
		return (
			<>
				<Modal isOpen={this.state.quickEditTaskModal} >
					<ModalHeader>
					</ModalHeader>
					<ModalBody>
						<b>Receiver : </b>
						<ComboBox id="receiver_id" name="receiver_id" onChange={(e)=>{this.onTaskChangeHandler(e); this.setState(e.target.value)} } table="rb_person" valueField="person_id" displayField="name,lastname,person_desc,person_tel" filterField="person_type" filterValue={"8' AND if(user_expire_date is not null,user_expire_date>now(),true) AND 'x'='x"} defaultValue={this.state.task_receiver_id} orderby="name" />
						<b>Task : </b>
						<Input id="task" type="text" onChange={(e)=>{this.setState({task_task			:	e.target.value});}} onBlur={this.onTaskChangeHandler}  value={this.state.task_task} />
						<b>Description : </b>
						<Input id="task_description" type="textarea" onChange={(e)=>{this.setState({task_description	:	e.target.value});}} onBlur={this.onTaskChangeHandler}  value={this.state.task_description} />
						<b>Percent Done : </b>
						<Input id="percent_done" type="text" onChange={(e)=>{this.setState({task_percent_done	:	e.target.value});}} onBlur={this.onTaskChangeHandler}  value={this.state.task_percent_done} />
						<b>Estimate Hours : </b>
						<Input id="estimate_hours" type="text" onChange={(e)=>{this.setState({task_estimate_hours	:	e.target.value});}} onBlur={this.onTaskChangeHandler}  value={this.state.task_estimate_hours} />
						<b>Real Minutes : </b>
						<Input id="real_hours" type="text" onChange={(e)=>{this.setState({task_real_hours	:	e.target.value});}} onBlur={this.onTaskChangeHandler}  value={this.state.task_real_hours} />
					</ModalBody>
					<ModalFooter>
						<Button color="primary" onClick={(e)=>{this.setState({quickEditTaskModal:false})}} >Close</Button>{' '}
						<Button color="secondary" onClick={(e)=>{this.setState({quickEditTaskModal:false})}} >Save</Button>{' '}
					</ModalFooter>
				</Modal>
			</>
		);
	}

    addNotification (_MESSAGE_, _TYPE_) {
		const notification = this.notificationSystem.current;
		notification.addNotification({message: _MESSAGE_, level: _TYPE_});
	};	
	onTaskChangeHandler	=	(e)=>{
		e.persist();
		this.runQuery("UPDATE rb_project_tasks SET " + e.target.id  + " = '" + e.target.value + "' WHERE pt_id =" + this.state.task_id, e.target.id + ' Updated!', "success");
	}
	
}

export default ViewProjectTask;